import React, { useEffect, useState } from 'react';

import Cookies from 'js-cookie';

import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';

type BucketOverride = {
  appPath: string;
  bucketId: string;
  bucketPath?: string;
};

const PrLabel = () => {
  const [bucketOverride, setBucketOverride] = useState<BucketOverride>();

  useEffect(() => {
    const bucketOverrideUnParsed = Cookies.get('bucketOverride');
    const bucketOverrideFromCookie = JSON.parse(bucketOverrideUnParsed || '{}');

    if (bucketOverrideFromCookie.bucketId) {
      setBucketOverride(bucketOverrideFromCookie);
    }
  }, []);

  const onExitClick = () => {
    Cookies.remove('bucketOverride', {
      path: bucketOverride?.appPath,
    });

    window.history.pushState({}, document.title, window.location.pathname);
    window.location.reload();
  };

  if (!bucketOverride) return null;

  return (
    <div
      css={[
        {
          position: 'fixed',
          padding: '0 5px',
          lineHeight: '18px',
          fontSize: 13,
          right: 0,
          background: theme.colors.pink500,
          color: theme.colors.white,
        },
      ]}
    >
      {`Preview ${bucketOverride?.bucketPath} | `}
      <LinkButton
        data-testid="exit-pr-site"
        style={{
          color: theme.colors.white,
          lineHeight: '13px',
        }}
        onClick={onExitClick}
      >
        exit
      </LinkButton>
    </div>
  );
};

PrLabel.displayName = 'PrLabel';

export default PrLabel;
